var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "horizontal-bar" }, [
    _vm.size !== "thick"
      ? _c("div", { staticClass: "horizontal-bar__value" }, [
          !_vm.text
            ? _c("span", [_vm._v(_vm._s(_vm.value + "%"))])
            : _c("span", [_vm._v(_vm._s(_vm.text))]),
        ])
      : _vm._e(),
    _c("div", { staticClass: "progress", class: _vm.horizontalBarType }, [
      _c(
        "div",
        {
          staticClass: "progress-bar horizontal-bar__progress-bar",
          class: _vm.horizontalBarAnimation,
          style: _vm.horizontalBarStyle,
        },
        [
          _vm.size === "thick"
            ? _c(
                "span",
                {
                  staticClass: "horizontal-bar__value",
                  class: { hidden: _vm.value == 0 },
                },
                [
                  !_vm.text
                    ? _c("span", [_vm._v(_vm._s(_vm.value + "%"))])
                    : _c("span", [_vm._v(_vm._s(_vm.text))]),
                ]
              )
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }